module.exports = __webpack_public_path__ + "img/serget2.087c4451.png";